import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';

// Other elements in the guidelines have not been implemented yet but can be added.

const HEADER_PROP_TYPES = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

interface HeaderProps {
  children: React.ReactNode;
  className?: string;
  dataTestAttrs?: DataTestAttrs;
}

export function Header1(props: HeaderProps): JSX.Element {
  return <h1 className={classNames(props.className, 'header--header1')}>{props.children}</h1>;
}
Header1.propTypes = HEADER_PROP_TYPES;

export function Header2(props: HeaderProps): JSX.Element {
  return (
    <h2 className={classNames(props.className, 'header--header2')} {...getTestProps(props.dataTestAttrs)}>
      {props.children}
    </h2>
  );
}
Header2.propTypes = HEADER_PROP_TYPES;

export function Header3(props: HeaderProps): JSX.Element {
  return <h3 className={classNames(props.className, 'header--header3')}>{props.children}</h3>;
}
Header3.propTypes = HEADER_PROP_TYPES;

export function Title(props: HeaderProps): JSX.Element {
  return <h3 className={classNames(props.className, 'header--title')}>{props.children}</h3>;
}
Title.propTypes = HEADER_PROP_TYPES;

export function Sublabel(props: HeaderProps): JSX.Element {
  return <div className={classNames(props.className, 'header--sublabel')}>{props.children}</div>;
}
Sublabel.propTypes = HEADER_PROP_TYPES;

interface PrefixedHeaderProps extends HeaderProps {
  prefix: string;
}
export function PrefixedHeader(props: PrefixedHeaderProps): JSX.Element {
  return (
    <Header1 className={props.className}>
      <span className="font-proxima-semibold">{props.prefix}</span> | {props.children}
    </Header1>
  );
}
PrefixedHeader.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  prefix: PropTypes.string.isRequired,
};
